import { HEADER_HEIGHT } from '../../pages/admin/EstheticianMessaging/Conversation/config';

export const containerStyles =
  (conversationIsSelected, mobileNavHeaderHeight, renderedWithinDrawer) =>
  theme => ({
    /** Height of the container - the 80px header and its 1px border-bottom */
    minHeight: conversationIsSelected
      ? `calc(90% - ${renderedWithinDrawer ? 72 : HEADER_HEIGHT}px)`
      : '90%',
    height: conversationIsSelected
      ? `calc(100% - ${renderedWithinDrawer ? 72 : HEADER_HEIGHT}px)`
      : '100%',
    backgroundColor: 'default.main',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    py: 3,

    [theme.breakpoints.down('sm')]: {
      minHeight: conversationIsSelected
        ? `calc(var(--app-height) - ${HEADER_HEIGHT}px - ${mobileNavHeaderHeight}px)`
        : '100%',
      height: conversationIsSelected
        ? `calc(var(--app-height) - ${HEADER_HEIGHT}px - ${mobileNavHeaderHeight}px)`
        : '100%',
      pb: 1,
    },
  });
